import {connect} from 'react-redux'
import ChangePassword from '../components/ChangePassword'
import {selectUserInfo} from '../../../../redux/modules/session'
import {toJS} from '../../../../util/ToJS'
import {postSaveChangePassword} from '../../../../redux/modules/session'
import {showModal} from '../../../../redux/modules/modal'

const mapDispatchToProps = dispatch => ({
  postSaveChangePassword: (currentPassword, newPassword) => dispatch(postSaveChangePassword(currentPassword, newPassword)),
  forgotPassword:() => dispatch(showModal('FORGOT_PASSWORD', {}))
})

export default connect(
  selectUserInfo,
  mapDispatchToProps
)(toJS(ChangePassword))



// WEBPACK FOOTER //
// ./src/domains/user/edit-profile/containers/VisibleChangePassword.js